import React, { useState } from 'react';
import axios from 'axios';
import TextField from '@mui/material/TextField';
import { toast } from 'react-toastify';
import { useAlert } from '../../alert/AlertContext';
import { Button, DialogActions, DialogContent, Stack } from '@mui/material';
import { generateRandomPassword } from './UserUtils';
import IconButton from '@mui/material/IconButton';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const ChangePasswordForm = ({ userId, afterChange, onSuccess }) => {

    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [reTypeNewPassword, setReTypeNewPassword] = useState("");
    const [oldPasswordError, setOldPasswordError] = useState(false);
    const [newPasswordError, setNewPasswordError] = useState(false);
    const [reTypeNewPasswordError, setReTypeNewPasswordError] = useState(false);
    const alert = useAlert();

    const handleOldPasswordChange = (e) => {
        setOldPasswordError(false);
        setOldPassword(e.target.value);
    };

    const handleNewPasswordChange = (e) => {
        setNewPasswordError(false);
        setNewPassword(e.target.value);
    };

    const handleReTypeNewPasswordChange = (e) => {
        setReTypeNewPasswordError(false);
        setReTypeNewPassword(e.target.value);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleChangePassword();
        }
    };

    const handleChangePassword = async () => {
        let hasErrors = false;
        if (!userId && !oldPassword) {
            setOldPasswordError(true);
            hasErrors = true;
        }
        if (!newPassword) {
            setNewPasswordError(true);
            hasErrors = true;
        }
        if (!reTypeNewPassword) {
            setReTypeNewPasswordError(true);
            hasErrors = true;
        }
        if (hasErrors) {
            return;
        }
        if (newPassword !== reTypeNewPassword) {
            alert("Change Password", "Passwords do not match");
            return;
        }
        const qs = require('qs');
        try {
            if (userId) {
                await axios.post(`/user-admin/password`, qs.stringify({ 'id': userId, 'newPassword': newPassword }));
            } else {
                const response = await axios.post('/user-admin/loggedIn/password', qs.stringify({ 'oldPassword': oldPassword, 'newPassword': newPassword }));
                toast.success(response.data);
            }
        } catch {
            return;
        }
        if (onSuccess) onSuccess();
        if (afterChange) afterChange(true);
    };

    const onRandomPassword = () => {
        const password = generateRandomPassword();
        setNewPassword(password);
        setReTypeNewPassword(password);
    };

    const copyToClipboard = () => {
        navigator.clipboard.writeText(newPassword);
        toast.success('Password copied to clipboard');
    };

    return (
        <>
            <DialogContent sx={{
                m: 0,
                p: 0,
                mt: 1,
                paddingLeft: '20px',
                paddingRight: '20px',
            }}>
                <Stack spacing={1}>
                    {!userId && <TextField
                        name="oldPassword"
                        label="Old Password"
                        variant="standard"
                        type="password"
                        value={oldPassword}
                        onChange={handleOldPasswordChange}
                        error={oldPasswordError}
                        autoFocus
                        noValidate
                        autoComplete="off"
                        InputProps={{ autoComplete: 'disabled', autocomplete: 'off' }}
                    />
                    }

                    <TextField
                        name="newPassword"
                        label="New Password"
                        variant="standard"
                        type="password"
                        value={newPassword}
                        onChange={handleNewPasswordChange}
                        error={newPasswordError}
                        autoFocus={!!userId}
                        noValidate
                        autoComplete="off"
                        InputProps={{ autoComplete: 'disabled', autocomplete: 'off' }}
                    />

                    <TextField
                        name="reTypeNewPassword"
                        label="Re Type New Password"
                        variant="standard"
                        type="password"
                        value={reTypeNewPassword}
                        onChange={handleReTypeNewPasswordChange}
                        onKeyDown={handleKeyPress}
                        error={reTypeNewPasswordError}
                        noValidate
                        autoComplete="off"
                        InputProps={{ autoComplete: 'disabled', autocomplete: 'off' }}
                    />
                </Stack>

                <Stack direction='row' alignItems='center' spacing={1}>
                    <Button onClick={onRandomPassword}>Random</Button>
                    <IconButton onClick={copyToClipboard}><ContentCopyIcon /></IconButton>
                </Stack>
            </DialogContent>
            {afterChange ?
                <DialogActions>
                    <Button fullWidth onClick={handleChangePassword}>Change Password</Button>
                    <Button fullWidth onClick={() => afterChange(false)}>Cancel</Button>
                </DialogActions>
                :
                <Button variant='contained' onClick={handleChangePassword}>Change Password</Button>
            }
        </>
    );
};

export default ChangePasswordForm;
